import ManagePostsTable from './ManagePostsTable';
export default ManagePostsTable;